import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/hooks/useProgressInfoTitle'
import { useAddNumberFromAppStepsContext } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppStepsContext'
import { type AddNumberFromAppStepsRoutes } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/lib/constants'

export const AddNumberFromAppStepsLayout = observer(() => {
  const { numbersLayerStore, allStepsLength, decreaseStep, setCurrentStep, getSettingsStep } =
    useAddNumberFromAppStepsContext()
  const settingsStep = useGetStep<AddNumberFromAppStepsRoutes>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Add number from app'
      settingsStep={settingsStep}
      closeSetting={numbersLayerStore.redirectToRoot}
      decreaseStep={decreaseStep}
    />
  )
})
